import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ROUTES, STORAGE_KEYS } from '@/constants';
import { useAppSelector, selectUser } from '@/store';

const GUARD_SKIP_PATHS = new Set<string>([
  ROUTES.login,
  ROUTES.otp,
  ROUTES.signup,
  ROUTES.plantSelection,
  ROUTES.changePlant,
  ROUTES.workModeSelection,
  ROUTES.breakMode,
  ROUTES.shuttleTransfer,
  ROUTES.logoutSummary,
  ROUTES.maintenance,
  ROUTES.error,
  ROUTES.restrictedArea,
]);

export function BreakModeGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);

  const breakActive = localStorage.getItem(STORAGE_KEYS.breakModeActive) === 'true';
  const isAuthenticated = !!user;
  const onSkippedPage = GUARD_SKIP_PATHS.has(location.pathname);
  const shouldRedirect = breakActive && isAuthenticated && !onSkippedPage;

  useEffect(() => {
    if (!shouldRedirect) return;

    const fromShuttle = localStorage.getItem(STORAGE_KEYS.breakModeFrom) === 'shuttle';
    const target = fromShuttle ? `${ROUTES.breakMode}?from=shuttle` : ROUTES.breakMode;
    navigate(target, { replace: true });
  }, [shouldRedirect, navigate]);

  return null;
}
